import React, {FC, useRef} from "react"
import styled from "styled-components"

import Player from "@vimeo/player"
import wellnessVideoPlayer from "@irati-web/platform/src/utils/wellnessVideoPlayer"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Card from "@irati/ui/src/experimental/Card"
import {WellnessMedia} from "@irati/types"
import tracking from "@irati-tracking/wellness"
import {onProgress} from "@shared/wellness/utils"

const PlayerWrapper = styled(Card)`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`

interface Props extends InjectIntl {
  media: WellnessMedia
}

const VideoPlayer: FC<Props> = ({media}) => {
  const {title, src} = media
  const playerRef = useRef(null)
  const isQuarterTracked = useRef(false)
  const isFinishTracked = useRef(false)
  const isMidTracked = useRef(false)
  const isThreeQuartersTracked = useRef(false)
  const videoHasStarted = useRef(false)

  wellnessVideoPlayer.setup().then(() => {
    const player = new Player(playerRef?.current)

    player.on("play", function(data) {
      const currentSeconds = Math.trunc(data.seconds)
      if (currentSeconds === 0) {
        // Reset all flags if we restart playback from scratch, so we can track if it gets finished again
        isFinishTracked.current = false
        isQuarterTracked.current = false
        isMidTracked.current = false
        isThreeQuartersTracked.current = false
      }

      if(!videoHasStarted.current) {
        videoHasStarted.current = true
        tracking.startMedia(media)
      }
    })

    player.on("progress", function(data) {
      const currentSeconds = Math.trunc(data.seconds)
      const totalSeconds = Math.trunc(data.duration)

      onProgress(currentSeconds, totalSeconds, media, isQuarterTracked, isMidTracked, isThreeQuartersTracked, isFinishTracked)
    })
  })

  return (
    <PlayerWrapper marginTop={5}>
      <iframe
        src={src}
        ref={playerRef}
        marginHeight={10}
        scrolling="no"
        title={title}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen />
    </PlayerWrapper>
  )
}

export default injectIntl(VideoPlayer)
